import React from 'react';
import { useDestinationEditor } from './DestinationEditorContext';
import { CountryDestinationBasicInfo } from './CountryDestinationBasicInfo';
import { PlaceDestinationBasicInfo } from './PlaceDestinationBasicInfo';

type DestinationEditorBasicInfoProps = Readonly<{
    onClickDiscard: (hasUnsavedChanges: boolean) => void;
}>;

export function DestinationEditorBasicInfo({ onClickDiscard }: DestinationEditorBasicInfoProps) {
    const { isCountry } = useDestinationEditor();

    return isCountry ? (
        <CountryDestinationBasicInfo onClickDiscard={onClickDiscard} />
    ) : (
        <PlaceDestinationBasicInfo onClickDiscard={onClickDiscard} />
    );
}
